import { Component } from 'react';
import { Notifier } from '@airbrake/browser';
import constants from '../constants';

class TunespeakNotifier extends Notifier {
  notify(props) {
    if (constants.env !== 'development') {
      return super.notify(props);
    }
  }
}

export const Airbrake = new TunespeakNotifier({
  projectId: constants.airbrakeProjectId,
  projectKey: constants.airbrakeProjectKey,
  environment: constants.env,
});

class ErrorBoundary extends Component {
  // constructor(props) {
  //   super(props);
  //   this.state = { hasError: false };
  // }

  componentDidCatch(error, info) {
    Airbrake.notify({
      error: error,
      context: {
        component: this.props.component
      },
      params: { info }
    });
  }

  render() {
    // if (this.state.hasError) {
    //   // You can render any custom fallback UI
    //   return <h1>Something went wrong.</h1>;
    // }
    return this.props.children;
  }
}

export default ErrorBoundary;
